import { en, type MessageKey, type Messages } from './en';

const catalog: Messages = en;

/**
 * Translate a key, with optional `{placeholder}` interpolation. Unknown keys
 * are impossible: `MessageKey` is a union of the catalog.
 */
export function t(key: MessageKey, params?: Record<string, string>): string {
  const template = catalog[key];
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => params[name] ?? match);
}

export type { MessageKey };
